// Generic placeholder for nav slots whose backing feature isn't shipped yet.

import { Construction, ArrowLeft } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

export default function ComingSoon({ title, blurb }: { title?: string; blurb?: string }) {
  const location = useLocation();
  const inferredTitle = title || guessTitle(location.pathname);
  return (
    <div className="space-y-4 max-w-2xl">
      <h1 className="text-2xl font-semibold flex items-center gap-2"><Construction /> {inferredTitle}</h1>
      <div className="card p-6 space-y-3">
        <p>This is the {inferredTitle} surface.</p>
        {blurb && <p className="text-textSecondary text-sm">{blurb}</p>}
        <p className="text-sm text-textSecondary">
          The underlying capability isn't exposed in Stratus yet. It's tracked
          in the master plan and will land in a future release.
        </p>
        <Link to="/" className="btn inline-flex items-center gap-1 text-sm w-fit">
          <ArrowLeft size={14} /> Back to Dashboard
        </Link>
      </div>
    </div>
  );
}

function guessTitle(path: string) {
  const last = path.split('/').filter(Boolean).pop() || 'Settings';
  return last.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
}
